import {includes} from 'ramda';

import {DASHBOARD_TILE_IDS} from '../consts/dashboardTileIds';
import {DashboardTileId} from '../types/DashboardTileId';

export function isDashboardTileId(value: string): value is DashboardTileId {
  return includes(value, DASHBOARD_TILE_IDS);
}
